import React, { FunctionComponent } from 'react';
import AtlassianSwitcher from '@atlaskit/atlassian-switcher';
import { IntlProvider } from 'react-intl';
import FabricAnalyticsListeners, {
  FabricChannel,
} from '@atlaskit/analytics-listeners';
import { Analytics } from '@trello/atlassian-analytics';
import API from 'app/gamma/src/api';
import { createProviderWithCustomFetchData } from '@atlaskit/atlassian-switcher/dist/esm/providers/create-data-provider';
import { N300, N800 } from '@trello/colors';

import styles from './AtlassianAppSwitcher.less';

const trelloTheme = {
  primaryTextColor: N800,
  secondaryTextColor: N300,
  primaryHoverBackgroundColor: '#E0E2E5',
  secondaryHoverBackgroundColor: '#F5F6F7',
};

const customAvailableProductsDataProvider = createProviderWithCustomFetchData(
  'availableProducts',
  API.client.atlassianSwitcherData,
);

export const AtlassianAppSwitcher: FunctionComponent = () => (
  <div className={styles.atlassianAppSwitcherContainer}>
    <IntlProvider locale="en">
      {
        //@ts-ignore
        <FabricAnalyticsListeners
          client={Analytics.dangerouslyGetAnalyticsWebClient()}
          excludedChannels={[
            FabricChannel.atlaskit,
            FabricChannel.elements,
            FabricChannel.editor,
            FabricChannel.media,
          ]}
        >
          {
            //@ts-ignore
            <AtlassianSwitcher
              product="trello"
              appearance="standalone"
              theme={trelloTheme}
              availableProductsDataProvider={
                customAvailableProductsDataProvider
              }
            />
          }
        </FabricAnalyticsListeners>
      }
    </IntlProvider>
  </div>
);
